let scriptsLoaded = false;

function loadScripts(e) {
  if (scriptsLoaded || (e && !e.isTrusted)) return;
  scriptsLoaded = true;

  setTimeout(function () {
    // loadScript("//www.wearcomet.com/cdn/shop/t/155/assets/cart-drawer.js?v=45654657555496281121763104199");
    loadCSS("//www.wearcomet.com/cdn/shop/t/155/assets/component-cart.css?v=61086454150987525971763104199");

    loadCSS("https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css");
    loadScriptWithCallBack('https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js', function(){
      if(window.innerWidth >= 992){

      //select elemets
      const swiperContainer = document.querySelector('.featured-collection-swiper');
      if(swiperContainer){
      swiperContainer.classList.add('swiper');

      document.querySelectorAll('.hp-featured-collection-slide').forEach(function(slide) {
        slide.classList.add('swiper-slide');
      });

      const swiperWrapper = document.createElement('div');
      swiperWrapper.classList.add('swiper-wrapper');

      const otherContent = swiperContainer.innerHTML;
      swiperWrapper.innerHTML = otherContent;

      swiperContainer.innerHTML = '';
      swiperContainer.appendChild(swiperWrapper);


      const swiper = new Swiper(".featured-collection-swiper", {
            slidesPerView: 3,
            spaceBetween: 0,
            slidesPerGroup: 3,
            // pagination: {
            //     el: ".swiper-pagination",
            //     clickable: true,
            // },
            // navigation: {
            //   nextEl: ".swiper-button-next",
            //   prevEl: ".swiper-button-prev"
            // },
            breakpoints: {
              1100: { slidesPerView: 4, slidesPerGroup: 2 },
            },
          });
      }
      }

      const testiSwiperContainer = document.querySelector('.hp-testimonial-container');
      if(testiSwiperContainer){
      const testiSwiper = new Swiper('.hp-testimonial-container', {
        slidesPerView: 1,
        spaceBetween: 30,
        slidesPerGroup: 1,
        navigation: {
          nextEl: '.testimonial-next',
          prevEl: '.testimonial-prev',
        },
        on: {
          init: function() {
            if(window.innerWidth <= 1000){
              var maxHeight = 0;
              document.querySelectorAll('.hp-testimonial-container .swiper-slide').forEach(function(slide) {
                maxHeight = Math.max(maxHeight, slide.offsetHeight);
              });
              document.querySelectorAll('.hp-testimonial-container .swiper-slide').forEach(function(slide) {
                slide.style.height = maxHeight + 'px';
                // document.querySelector('.hp-testimonial-container .swiper-wrapper').style.height = maxHeight + 'px';
                slide.querySelector('.testimonial-inner-block').style.height = maxHeight - 44 + 'px';

              });
            }
          }
        },
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true,
        // },
        breakpoints: {
          1000: {
            slidesPerView: 1.1,
            slidesPerGroup: 1,
            spaceBetween: 38
          },

          750: {
            slidesPerView: 1.1,
            slidesPerGroup: 1,
            spaceBetween: 30
          }
        }
      });
      }

      const announcementSwiperContainer = document.querySelector('.announcement-slider');
      if(announcementSwiperContainer){
        const announceSwiper = new Swiper('.announcement-slider', {
        loop: true,
        speed: 300,
        slidesPerView: 1,
        slidesPerGroup: 1,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        navigation: false, // No arrows
        pagination: false, // No dots
      });
    }

    // document.getElementById('dev_annoucement-bar-slick-placeholder').style.display = 'none';

    const logossSwiperContainer = document.querySelector('.logo-sliders-swiper');
    if(logossSwiperContainer){
      const logossSwiper = new Swiper('.logo-sliders-swiper', {
        loop: false,
        // speed: 300,
        slidesPerView: 3,
        slidesPerGroup: 3,
        navigation: false,
        pagination: false,
        breakpoints: {
          481: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          601: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            loop: true, 
          },
          1025: {
            slidesPerView: 6,
            slidesPerGroup: 3,
            loop: false, // Slick had `infinite: false` on desktop
          }
        }
      });
  }

      document.querySelectorAll('.placeholder-slk-prnt')?.forEach(el => {
        el.style.opacity = '0';
      });

      document.querySelectorAll('.onrendered-slider-prnt')?.forEach(el => {
        el.style.opacity = '1';
      });
    });
  
  }, 10);

  document.removeEventListener('click', loadScripts);
  document.removeEventListener('mouseover', loadScripts);
  document.removeEventListener('scroll', loadScripts);
}

if (window.scrollY >= 400) {
  loadScripts();
} else {
  document.addEventListener('mouseover', loadScripts);
  document.addEventListener('click', loadScripts);
  document.addEventListener('scroll', loadScripts);
}

function loadScript(src) {
  var script = document.createElement('script');
  script.src = src;
  script.async = true;
  document.head.appendChild(script);
}

function loadScriptWithCallBack(src, callback) {
  var script = document.createElement('script');
  script.src = src;
  script.onload = callback || function () {};
  document.head.appendChild(script);
}

function loadCSS(href) {
  var link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  document.head.appendChild(link);
}